module.exports = __webpack_public_path__ + "img/51626500_L.5686af48.png";